import React, { useState } from 'react';
import './HRAssistantTab.css';
import HRAssistantOutputsSubTab from './HRAssistantOutputsSubTab';

function HRAssistantTab() {
  const [activeSubTab, setActiveSubTab] = useState('outputs');

  return (
    <div className="hr-assistant-tab">
      <div className="sub-tabs">
        <button
          className={`sub-tab-button ${activeSubTab === 'outputs' ? 'active' : ''}`}
          onClick={() => setActiveSubTab('outputs')}
        >
          Ответы на сообщения
        </button>
      </div>
      <div className="sub-tab-content">
        {activeSubTab === 'outputs' && <HRAssistantOutputsSubTab />}
      </div>
    </div>
  );
}

export default HRAssistantTab;
